import { render, staticRenderFns } from "./AreaChange.vue?vue&type=template&id=a1d44b0a&"
import script from "./AreaChange.vue?vue&type=script&lang=js&"
export * from "./AreaChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports